var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJerry({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_385",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29248",
    "data-name": "Group 29248",
    transform: "translate(657 10935)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -657, -10935)",
    filter: "url(#Ellipse_385)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_385-2",
    "data-name": "Ellipse 385",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-jerry",
    transform: "translate(-641.075 -10923.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50108",
    "data-name": "Path 50108",
    d: "M32.634,7.877C29.317,4.56,26,16.17,26,16.17l9.121,1.658S36.365,11.609,32.634,7.877Z",
    transform: "translate(-3.744)",
    fill: "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50109",
    "data-name": "Path 50109",
    d: "M20.652,13.975c2.488-1.658,9.121-2.488,9.121-2.488s-7.081.223-8.292.829A5.79,5.79,0,0,0,23.139,9s-2.488,4.146-6.634,4.146c0,0-6.219-7.048-10.78-2.488-2.9,2.9-1.658,17.414,9.7,20.266.963.242,2.625,3.5,7,4.376,3.3.66,19.182-2.414,12.412-8.181a1.7,1.7,0,0,1-.5-1.818,9.086,9.086,0,0,0,.4-5.522c-.492-1.689-.829-3.317-4.975-4.975C27.455,13.878,20.652,13.975,20.652,13.975Z",
    transform: "translate(-0.054 -0.294)",
    fill: "#fb8c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50110",
    "data-name": "Path 50110",
    d: "M10.647,21.01s2.488,3.317,4.146,0c2.108-4.215-5.62-11.747-9.121-9.121S4.013,29.3,15.376,31.325c0,0-3.209-5.2-.583-7.828C14.793,23.5,12.4,25.386,10.647,21.01Z",
    transform: "translate(0 -0.694)",
    fill: "#ffcdd2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50111",
    "data-name": "Path 50111",
    d: "M28.672,29.336s-5.883-9.56-1.471-9.131a3.14,3.14,0,0,1,2.308,1.473,8.773,8.773,0,0,1,.913,7.659h-1.75Z",
    transform: "translate(-3.669 -2.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50112",
    "data-name": "Path 50112",
    d: "M36.514,29.545s-2.525-9.816.875-7.877c1.862,1.061.876,7.877.876,7.877Z",
    transform: "translate(-5.386 -2.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50113",
    "data-name": "Path 50113",
    d: "M31.476,28.7c0-1.493-.484-2.7-1.082-2.7s-1.082,1.211-1.082,2.7a5.7,5.7,0,0,0,.221,1.623h1.721A5.707,5.707,0,0,0,31.476,28.7Z",
    transform: "translate(-4.31 -3.197)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50114",
    "data-name": "Path 50114",
    d: "M37.419,28.032c0-1.208-.392-2.187-.875-2.187-.287,0-.534.362-.692.9.266,1.819.692,3.479.692,3.479C37.028,30.221,37.419,29.241,37.419,28.032Z",
    transform: "translate(-5.427 -3.17)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50115",
    "data-name": "Path 50115",
    d: "M27.356,31.159a6.431,6.431,0,0,1,5.251.875s2.625-2.625,4.376,0c0,0,.875,1.75-1.75,2.625,0,0,.432,2.86-3.944,4.611,0,0-1.244,4.561-5.8,0a11.666,11.666,0,0,1-2.5-5.485S29.981,35.535,27.356,31.159Z",
    transform: "translate(-3.228 -4.028)",
    fill: "#ffe082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50116",
    "data-name": "Path 50116",
    d: "M34.292,35.658c-.684.249-1.169-.464-1.169-.464-3.415,1.707-5.159-.742-5.243-.864-.244.141-1.545-.38-1.88-.33l.829,2.488c1.658,4.975,3.668,3.082,3.668,3.082C32.3,37.165,32.634,36.487,34.292,35.658Z",
    transform: "translate(-3.744 -4.562)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50117",
    "data-name": "Path 50117",
    d: "M28.309,37.344A1,1,0,0,0,27,36.978c1.658,6.634,4.146,2.488,4.146,2.488A2.718,2.718,0,0,0,28.309,37.344Z",
    transform: "translate(-3.915 -5.053)",
    fill: "#ff5252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50118",
    "data-name": "Path 50118",
    d: "M33.489,32.094l1.265,1.265a.825.825,0,0,0,1.076.084c.984-.736,2.489-2.224-1.465-2.224C32.614,31.219,33.489,32.094,33.489,32.094Z",
    transform: "translate(-4.986 -4.088)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50119",
    "data-name": "Path 50119",
    d: "M26.463,29s4.975,6.634-3.317,4.975L19,33.146Z",
    transform: "translate(-2.549 -3.709)",
    fill: "#fb8c00"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_442",
    "data-name": "Ellipse 442",
    cx: 0.829,
    cy: 0.277,
    rx: 0.829,
    ry: 0.277,
    transform: "translate(28.987 27.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50120",
    "data-name": "Path 50120",
    d: "M36,18.794a3.042,3.042,0,0,1,1.409-.422,4.953,4.953,0,0,1,1.352.1,6.047,6.047,0,0,0-.787-.685,4.733,4.733,0,0,0-.653.176A3.235,3.235,0,0,0,36,18.794Z",
    transform: "translate(-5.452 -1.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50121",
    "data-name": "Path 50121",
    d: "M23.5,20.78a4,4,0,0,1,.419-2.032,2.554,2.554,0,0,1,1.7-1.415,3.188,3.188,0,0,1,2.142.428,8.889,8.889,0,0,1,.839.617c.246.242.487.484.707.743-.315-.143-.609-.3-.9-.462s-.6-.258-.886-.4a3.349,3.349,0,0,0-1.743-.216,2.4,2.4,0,0,0-1.347,1.017A9.462,9.462,0,0,0,23.5,20.78Z",
    transform: "translate(-3.316 -1.708)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJerry);
export default __webpack_public_path__ + "static/media/jerry.14187fafaa4494c65714e025d9c8bcf1.svg";
export { ForwardRef as ReactComponent };